import OrderStatusEnum from '../../models/order-status-enum';

const useOrderStatusColor = (status: OrderStatusEnum): string => {
  if (status === OrderStatusEnum.Cancelled) {
    return 'invalid';
  }

  if (status === OrderStatusEnum.OnReferral) {
    return 'success';
  }

  if (status === OrderStatusEnum.Pending) {
    return 'grey-600';
  }

  if (status === OrderStatusEnum.TrackOrder) {
    return 'turquoise';
  }

  return 'french-blue';
};

export default useOrderStatusColor;
